import { HostListener, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {

  // PIT40803 \\
  private listaDePedidosOptionKey: string = 'ListaDePedidosOptionKey';
  private origemPedidoOptionKey: string = 'OrigemPedi';

  public setItem<T>(key: string, value: T): void{
    if (value != null) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }

  public getItem<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) as T : null;
  }

  public removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  // Apagar toda a informação em cache
  public clearData(): void {
    sessionStorage.clear();
  }

  // Remover os dados da cache dos filtros de pesquisa
  public removeListaDePedidosOption() {
    this.removeItem(this.listaDePedidosOptionKey);
  }

  // Obter dados da cache da origem do pedido
  public getOrigemPedidoOptionOnCache() {
    const inCachePedi: models.OrigemAcessoInstanciaVM | null = this.getItem(this.origemPedidoOptionKey);
    return inCachePedi;
  }

  // Obter dados da cache dos filtros de pesquisa
  public getListaDePedidosOptionOnCache() {
    const inCache: models.ListaPedidosOptionsVM | null = this.getItem(this.listaDePedidosOptionKey);
    return inCache;
  }

  // Alteração da cache dos filtros de pesquisa
  public setListaDePedidosOptionOnCache(listaDePedidosOption: models.ListaPedidosOptionsVM) {
    this.setItem(this.listaDePedidosOptionKey, listaDePedidosOption);
  }

  // Alteração da cache da origem do pedido
  public setOrigemPedidoOnCache(origemPedidoOption: models.OrigemAcessoInstanciaVM) {
    this.setItem(this.origemPedidoOptionKey, origemPedidoOption);
  }

}
